import { motion } from "framer-motion";

export function Reveal({ children, delay = 0, y = 44, className = "" }) {
    return (
        <motion.div
            className={className}
            initial={{ opacity: 0, y }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-60px" }}
            transition={{ duration: 0.9, delay, ease: [0.16, 1, 0.3, 1] }}
        >
            {children}
        </motion.div>
    );
}

export function Overline({ children, dark = false, testId }) {
    return (
        <p data-testid={testId} className={`text-[11px] font-semibold uppercase tracking-[0.35em] ${dark ? "text-[#D60024]" : "text-[#D60024]"}`}>
            {children}
        </p>
    );
}
